import React, { Component } from 'react';
import LeadSearch from './LeadSearch';
import SectionList from './SectionList';
import { Button } from '@blueprintjs/core';
import NewLeadContainer from '../../containers/leadtracker/NewLeadContainer';
import EditLeadContainer from '../../containers/leadtracker/EditLeadContainer';

class LeadTracker extends Component {

	render() {
		return (
			<div className="content">
				<div className="content_center">
					<div className="content_header">
						<div className={"content_header_title"}>
							Lead Tracker
								</div>
					</div>

					<div className="content_panel">
						{this.switch()}
					</div>
				</div>
			</div>
		);
	}


	switch = () => {
		const { mode } = this.props;
		switch (mode) {
			case 'search':
				return this.search()
			case 'edit':
				return this.edit()
			case 'new':
				return this.new()
		}
	}

	buttons = () => {
		const { gotoNewLead } = this.props;
		return (
			<div>
				<Button icon="add" onClick={gotoNewLead} >
					New Lead
				</Button>
			</div>
		)
	}

	search = () => {
		const { sections } = this.props;
		return (

			<div>
				{this.buttons()}

				<LeadSearch
					searchOnChange={this.props.searchOnChange}
					searchText={this.props.searchText}
				/>
				<SectionList sections={sections} gotoEditLead={this.props.gotoEditLead} />
			</div>
		)
	}

	edit = () => {
		return <EditLeadContainer gotoMode={this.props.gotoMode} />
	}

	new = () => {
		return <NewLeadContainer gotoMode={this.props.gotoMode} />
	}
}
export default LeadTracker;


// WEBPACK FOOTER //
// ./src/components/leadtracker/LeadTracker.js